import React from 'react';

import { Grid, Typography } from '@mui/material';

import { DEFAULT_VALUE_IF_NIL } from '@clearverify/constants';
import type { Nullable } from '@clearverify/types';

import { useScreenInfo } from 'src/hooks/common';

interface DetailGridItemProps {
  topText: string;
  bottomText: Nullable<string>;
  withContainer?: boolean;
}

export const DetailGridItem: React.FC<DetailGridItemProps> = ({
  topText,
  bottomText,
  withContainer = true,
}) => {
  const { isMobile } = useScreenInfo();
  if (isMobile) {
    return (
      <Grid container size={12}>
        <Grid size={4}>
          <Typography variant="body1" color="text.secondary">
            {topText}
          </Typography>
        </Grid>
        <Grid size={8}>
          <Typography variant="body1">{bottomText || DEFAULT_VALUE_IF_NIL}</Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container={withContainer} size={12}>
      <Grid size={3}>
        <Typography variant="body1" color="text.secondary">
          {topText}
        </Typography>
      </Grid>
      <Grid size={9}>
        <Typography variant="body1">{bottomText || DEFAULT_VALUE_IF_NIL}</Typography>
      </Grid>
    </Grid>
  );
};
